<template>
  <v-container fluid style="background-color: #203550" class="pt-16">
    <v-row>
      <v-col sm="12" md="6" class="mb-4">
        <v-card elevation="13" class="rounded-xl" outlined height="100%">
          <v-row class="pb-5">
            <v-col cols="1"></v-col>
            <v-col cols="10" class="pt-0"><v-app-bar color="#edb730" class="rounded-xl"></v-app-bar> </v-col>
            <v-col cols="1"></v-col>
          </v-row>

          <v-card-text class="pb-16">
            <v-row justify="center">
              <div class="text-h4 orange--text text--lighten-2">Calculadora</div>
            </v-row>
            <v-form ref="form" v-model="valid">
              <v-row class="pl-6">
                <v-col cols="8">
                  <v-text-field v-model="peso" :rules="pesoRules" type="number" label="Peso (En Libras)" required @change="redondeoPeso()"></v-text-field>
                </v-col>
                <v-col cols="2" class="pt-10">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on"> mdi-information </v-icon>
                    </template>
                    <span
                      >En este espacio puedes digitar el peso en lbs; ten en cuenta las siguientes recomendaciones:<br />
                      • Digita el peso de tu producto + El peso del empaque de tu producto (esta información la puedes obtener en el lugar donde realizas tu
                      compra o de lo contrario digita un estimado. Ejemplo: Peso del producto 4lbs + Peso del empaque 3 lbs, Total: 7 lbs), esto te ayudará a
                      tener una cotización más acertada y aproximada <br />
                      • La tarifa mínima de lbs que Mi Encarguito factura son 8 lbs, lo que significa que, a cualquier valor inferior a esta cantidad, se le
                      cobrará la misma tarifa. <br />
                      • Es importante que tengas en cuenta que Mi Encarguito redondea el peso total de la mercancía: los decimales menores o iguales a .4 se
                      aproximarán al número menor, y los mayores o iguales a .5 se aproximarán al número mayor <br />
                      • Sobres o cajas que pesen menos de 1 lb se aproximarán a 1lb
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="destino"
                    :items="cities"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="city"
                    item-value="city"
                    label="Destino"
                    placeholder="Start typing to Search"
                    :rules="destinoRules"
                    required
                    @change="deleteTotalCop()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="2" class="pt-10">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on"> mdi-information </v-icon>
                    </template>
                    <span>• Ten en cuenta que la tarifa costo por lb para-Bogotá es más económica que para las demás ciudades.</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="valorComercial"
                    :rules="valorComercialRules"
                    type="number"
                    label="Valor comercial (En Dólares)"
                    required
                    @change="deleteTotalCop()"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pt-10">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on"> mdi-information </v-icon>
                    </template>
                    <span
                      >En este espacio digita el valor total comercial de tu mercancía; ten en cuenta los siguientes puntos: <br />
                      • Si deseas enviar solo un producto digita su valor comercial aquí. <br />
                      • Si deseas enviar varios productos suma la cantidad del valor comercial de todos tus productos y digita el total aquí.
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="8">
                  <v-select
                    :items="items"
                    v-model="itemSelect"
                    return-object
                    label="¿Alguno de sus  productos individuales supera los $200?"
                    :rules="seleccionRules"
                    required
                    @change="changeMercancia()"
                    ><template #label="">
                      <span>¿Alguno de tus <strong> productos individuales </strong> supera los $200?</span>
                    </template></v-select
                  >
                </v-col>
                <v-col cols="2" class="pt-10">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on"> mdi-information </v-icon>
                    </template>
                    <span
                      >• Si dentro de tu lista de mercancía posees algún/os producto/os que su valor comercial supere los 200 USD responde “Si”, de lo contrario
                      responde “No”.</span
                    >
                  </v-tooltip>
                </v-col>
                <v-col cols="8" v-if="itemSelect == 'Si'">
                  <v-text-field
                    v-model="valorIndividual"
                    :rules="valorIndividualRules"
                    label="¿Cuál es el valor de estos artículos? (En Dólares)"
                    type="number"
                    required
                    @change="deleteTotalCop()"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pt-10" v-if="itemSelect == 'Si'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on"> mdi-information </v-icon>
                    </template>
                    <span>• Digita el valor de tu producto mayor a $200, de lo contrario si es más de un artículo suma sus valores y digítalos aquí.</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-row v-show="$vuetify.breakpoint.xs" class="justify-center">
            <v-btn color="#edb730" light elevation="12" x-large class="text-transform-none" :disabled="!valid" @click="calcular()">
              <v-icon> mdi-calculator </v-icon>
              <span class="text-h5 text--lighten-2 text-capitalize"> Calcular</span></v-btn
            >
          </v-row>
        </v-card>
      </v-col>

      <v-col class="mb-4" sm="12" md="6">
        <v-card elevation="13" class="rounded-xl" outlined height="100%">
          <v-row class="pb-5">
            <v-col cols="1"></v-col>
            <v-col cols="10" class="pt-0"><v-app-bar color="#edb730" class="rounded-xl"></v-app-bar> </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-card-text class="pl-6 pr-6 text-wrap">
            <v-row justify="center">
              <div class="text-h4 orange--text text--lighten-2 text-center">Descripción del Envio</div>
            </v-row>
            <v-col class="pt-6 pl-6 pr-6">
              <v-row class="pt-7 justify-space-between">
                <v-col md="8" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">Fletes (En Dólares)</div>
                </v-col>
                <v-col md="3" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">{{ formatNumber(flete) }}</div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pt-7 justify-space-between">
                <v-col md="8" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">Seguro contra robo (En Dolares)</div>
                </v-col>
                <v-col md="3" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">{{ formatNumber(seguro) }}</div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pt-7 justify-space-between">
                <v-col md="8" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">Impuestos Aduanales</div>
                </v-col>
                <v-col md="3" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">{{ formatNumber(impuestos) }}</div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pt-7 justify-space-between">
                <v-col md="8" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">Total en Dolares (USD)</div>
                </v-col>
                <v-col md="3" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">{{ formatNumber(totalUsd) }}</div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pt-7 justify-space-between">
                <v-col md="8" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">Tasa de cambio al día de hoy (TRM)</div>
                </v-col>
                <v-col md="3" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">{{ formatNumber(valores.trm) }}</div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pt-7 justify-space-between">
                <v-col md="8" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">Total pesos Colombianos (COP)</div>
                </v-col>
                <v-col md="3" sm="6">
                  <div class="text-subtitle-1 blue-grey--text text--darken-3">{{ formatNumber(totalCop) }}</div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-show="!$vuetify.breakpoint.xs" class="justify-center pt-10">
      <v-btn color="#edb730" light elevation="12" x-large class="text-transform-none" :disabled="!valid" @click="calcular()">
        <v-icon> mdi-calculator </v-icon>
        <span class="text-h5 text--lighten-2 text-capitalize"> Calcular</span></v-btn
      >
    </v-row>

    <v-row justify-md="center">
      <v-col md="2" class="d-none d-md-block"></v-col>
      <v-col md="6" xs="12">
        <v-text-field v-model="correo" solo label="Te enviamos tu cotización" placeholder="Digita tu correo electrónico"></v-text-field>
      </v-col>
      <v-col md="2" xs="1">
        <v-btn color="#edb730" light x-large :disabled="!totalCop" @click="sendCotizacion()">
          <v-icon> mdi-send </v-icon>
          <span class="text-h5 text--lighten-2 text-capitalize">Enviar</span></v-btn
        ></v-col
      >
    </v-row>

    <v-row justify-md="center">
      <v-col md="4" sm="12" class="text-h6 white--text text-md-center text-justify">
        Esta Cotización es un aproximado, para una cotización garantizada debes registrarte y dirigirte a la sección de cotizaciones. Si requieres más
        información comunícate con nosotros por WhatsApp.
      </v-col>
    </v-row>

    <v-row justify="space-around">
      <v-col md="1" sm="12">
        <v-btn
          x-large
          block
          width="16rem"
          height="8rem"
          rounded
          class="btn-multiline pl-sm-6"
          color="amber accent-3"
          light
          :href="`https://app.miencarguito.com/register`"
        >
          <span class="text-wrap text-md-center"
            >Regístrate y abre Tu casillero <br /><span class="text-h6">¡GRATIS! <v-icon> mdi-cursor-default-click-outline </v-icon> </span></span
          >
        </v-btn>
      </v-col>
      <v-col md="2" sm="4">
        <a href="https://api.whatsapp.com/send?l=es&phone=13056991676" target="_blank" height="100">
          <v-img :src="require('../assets/whatsapp.png')" contain width="16rem" height="8rem" />
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="6" class="mb-4">
        <v-card d-flex class="rounded-xl" outlined color="#203550" style="min-height: 350px; border: 2px solid white">
          <v-card-text class="text-justify">
            <span class="text-h6 pt-10 white--text text--darken-2 text-justify">
              <strong>Notas:</strong><br />
              <br />
            </span>
            <v-list-item v-for="(item, i) in itemsLista" :key="i" dark dense>
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text" class="text-subtitle-1 white--text text--darken-2 text-wrap"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="12" md="6" class="mb-4">
        <v-card d-flex class="rounded-xl" color="#203550" outlined style="min-height: 350px; border: 2px solid white">
          <v-card-text>
            <span class="text-subtitle-1 pt-10 white--text text--darken-2 text-justify">
              <strong>Nunca cobramos por:</strong><br />
              <br />

              <v-icon color="white"> mdi-close </v-icon> Cargo por consolidación<br />
              <v-icon color="white"> mdi-close </v-icon> Cargo de combustible <br />
              <v-icon color="white"> mdi-close </v-icon> Cargo de Bodegaje<br />
              <v-icon color="white"> mdi-close </v-icon> Sobrecargo Ministerio Comunicaciones<br />
              <v-icon color="white"> mdi-close </v-icon> Cargo por despacho fuera de Bogotá<br />
              <v-icon color="white"> mdi-close </v-icon> Volumen<br />
              <v-icon color="white"> mdi-close </v-icon> Membresías<br />
              <v-icon color="white"> mdi-close </v-icon> Cargos por documentación<br />
              <v-icon color="white"> mdi-close </v-icon> Re-ajustes Aduana (Términos & Condiciones aplican)
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbarSuccess" :multi-line="true" color="success" centered>
      Cotización enviada correctamente

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbarSuccess = false"> <v-icon> mdi-close </v-icon></v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarError" :multi-line="true" color="error" centered>
      Cotización no enviada

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarError = false"> <v-icon> mdi-close </v-icon></v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import decimal from 'decimal';
export default {
  name: 'Calculadora',

  data: () => ({
    items: ['Si', 'No'],
    itemSelect: '',
    seleccionRules: [(v) => !!v || 'Selección is required'],
    peso: null,
    pesoRules: [(v) => !!v || 'Peso is required', (v) => v > 0 || 'Insert a valid value'],
    cities: [],
    isLoading: false,
    destino: null,
    destinoRules: [(v) => !!v || 'Destino is required'],
    valorComercial: '',
    valorComercialRules: [(v) => !!v || 'Valor Comercial is required', (v) => v > 0 || 'Insert a valid value'],
    valorIndividual: '',
    valorIndividualRules: [(v) => !!v || 'Valor individual is required', (v) => v > 199 || 'Insert a valid value'],
    cities: [],
    valid: false,
    valores: [],
    flete: null,
    seguro: null,
    impuestos: null,
    trm: null,
    totalUsd: null,
    totalCop: null,
    formatter: new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }),
    itemsLista: [
      {
        icon: 'mdi-circle-small',
        text: 'La tarifa min de libras que factura Mi Encarguito es de 8 lbs.',
      },
      {
        icon: 'mdi-circle-small',
        text: 'Sobres o cajas que pesen menos de 1 lb se aproximarán a 1lb.',
      },
      {
        icon: 'mdi-circle-small',
        text: 'Todo peso digitado con decimales menores o iguales a .4 se aproximarán al número menor, y los mayores o iguales a .5 se aproximarán al número mayor.',
      },
      {
        icon: 'mdi-circle-small',
        text: 'El total de Peso del producto debe incluir el peso de su empaque para así obtener una cotización más aproximada.',
      },
      {
        icon: 'mdi-circle-small',
        text: 'El valor en pesos colombianos está sujeto a la tasa representativa del mercado que cambia diariamente',
      },
    ],
    model: 1,
    correo: '',
    snackbarSuccess: false,
    snackbarError: false,
  }),
  created() {
    this.getCities();
    this.getInfo();
  },
  methods: {
    getCities() {
      this.isLoading = true;
      axios.get('https://app.miencarguito.com/api/citiesCalculator').then((result) => {
        this.cities = result.data.cities;
        this.isLoading = false;
      });
    },
    getInfo() {
      axios.get('https://app.miencarguito.com/api/infoCalculator').then((result) => {
        //axios.get('http://localhost:8000/api/infoCalculator').then((result) => {
        this.valores.seguro = result.data.prices[0].value;
        this.valores.costoLbBogota = result.data.prices[1].value;
        this.valores.costoLbNoBogota = result.data.prices[2].value;
        this.valores.libras = result.data.prices[3].value;
        this.valores.impuestos = result.data.prices[4].value;
        this.valores.descuentoMayor200 = result.data.prices[5].value;
        this.valores.descuentoMayor500 = result.data.prices[6].value;
        this.valores.trm = result.data.trm;
      });
    },
    calcular() {
      this.$refs.form.validate();
      const tarifaEnvio = this.destino == 'BOGOTA' ? this.valores.costoLbBogota : this.valores.costoLbNoBogota;
      const libras = this.peso > this.valores.libras ? this.peso : this.valores.libras;
      this.flete = decimal(libras).mul(tarifaEnvio);
      this.peso > 200 && this.peso <= 500
        ? (this.flete = decimal(this.flete)
            .mul(100 - this.valores.descuentoMayor200)
            .div(100))
        : this.flete;

      this.peso > 500
        ? (this.flete = decimal(this.flete)
            .mul(100 - this.valores.descuentoMayor500)
            .div(100))
        : this.flete;
      this.seguro = decimal(this.valorComercial).mul(this.valores.seguro).div(100);
      this.impuestos = decimal(this.valorIndividual || 0)
        .mul(this.valores.impuestos)
        .div(100);
      this.trm = this.valores.trm;
      this.totalUsd = decimal(this.flete).add(this.seguro).add(this.impuestos);
      this.totalCop = decimal(this.totalUsd).mul(this.valores.trm);
      this.totalCop = Math.round(this.totalCop);
    },
    changeMercancia() {
      this.deleteTotalCop();
      this.valorIndividual = '';
    },
    formatNumber(value) {
      if (value == null) {
        return '';
      }
      const formatted = this.formatter.format(value);
      return formatted;
    },
    sendCotizacion() {
      if (this.correo == '') return console.error('vacio');

      axios
        .post('https://app.miencarguito.com/api/sendCotizacion', {
          email: this.correo,
          peso: this.peso,
          destino: this.destino,
          valorComercial: this.valorComercial,
          valorTotal: this.valorIndividual,
          totalFlete: this.formatNumber(this.flete),
          seguro: this.formatNumber(this.seguro),
          impuesto: this.formatNumber(this.impuestos),
          totalUSD: this.formatNumber(this.totalUsd),
          tasaCambio: this.formatNumber(this.trm),
          total: this.formatNumber(this.totalCop),
        })
        .then((response) => {
          response.data.enviado ? (this.snackbarSuccess = true) : (this.snackbarError = true);
        })
        .catch((error) => {
          this.snackbarError = true;
          console.log(error);
        });
    },
    redondeoPeso() {
      this.deleteTotalCop();
      this.peso = Math.round(this.peso);
    },
    deleteTotalCop() {
      this.totalCop = 0;
    },
  },
};
</script>
<style lang="scss">
$card-outlined-border-width: bold;
.btn-multiline > span {
  width: 100%;
}
.text-justify {
  text-align: justify;
  text-justify: inter-word;
}
</style>
